import { Box, Modal, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import { Toast } from "../../../../components/Toast";
import TextButton from "../../../../components/buttons/TextButton";
import FormTextField from "../../../../components/forms/FormTextField";

const AttachExistingCustomerToMSSPModal = ({ open, handleClose }) => {
  const colors = useColors();
  const { attachExistingCustomerToMSSP } = useAPI();
  const [isLoading, setIsLoading] = useState(false);

  const formInitialValues = {
    customerId: "",
    msspId: "",
  };

  const formValidationSchema = yup.object().shape({
    customerId: yup.string().required("Customer ID is required"),
    msspId: yup.string().required("MSSP ID is required"),
  });

  const onSubmit = async (values) => {
    setIsLoading(true);

    try {
      await attachExistingCustomerToMSSP(values.customerId, values.msspId);
      Toast.success("Customer attached to MSSP successfully");
      handleClose();
    } catch (error) {
      Toast.error(
        error?.response?.content || "Failed to attach customer to MSSP"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
    >
      <Box
        sx={{
          width: 500,
          bgcolor: "background.paper",
          margin: "auto",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          overflowY: "auto",
          borderRadius: "10px",
        }}
      >
        <Box sx={{ width: 420, overflowY: "auto", padding: 2 }}>
          {/* Title */}
          <Typography
            variant="subtitle1"
            sx={{
              marginBottom: 3,
              color: colors.text_primary,
              textAlign: "center",
            }}
          >
            Attach Existing Customer to MSSP
          </Typography>

          {/* Form */}
          <Formik
            onSubmit={onSubmit}
            initialValues={formInitialValues}
            validationSchema={formValidationSchema}
            enableReinitialize
          >
            {({ handleSubmit }) => (
              <Form onSubmit={handleSubmit}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    paddingRight: 2,
                  }}
                >
                  <FormTextField
                    label="Customer ID"
                    fieldName="customerId"
                    required
                    helperText="The existing customer ID to attach"
                  />

                  <FormTextField
                    label="MSSP ID"
                    fieldName="msspId"
                    required
                    helperText="The MSSP ID to attach the customer to"
                  />
                </Box>

                {/* Buttons */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 2,
                    alignItems: "center",
                    marginTop: "32px",
                    marginBottom: "24px",
                  }}
                >
                  <TextButton
                    onClick={handleClose}
                    disabled={isLoading}
                    loading={isLoading}
                    color="inherit"
                  >
                    Cancel
                  </TextButton>
                  <TextButton
                    onClick={handleSubmit}
                    disabled={isLoading}
                    loading={isLoading}
                    color="primary"
                  >
                    Attach Customer
                  </TextButton>
                </Box>
              </Form>
            )}
          </Formik>
        </Box>
      </Box>
    </Modal>
  );
};

export default AttachExistingCustomerToMSSPModal;
